import React from 'react';
import { Button } from "@/components/ui/button";
import { Mail, Linkedin, Calendar } from 'lucide-react';
import { toast } from "sonner";

export const DirectContact = () => {
  const handleScheduleCall = () => {
    toast.message("Scheduling a call", {
      description: "Opening Google Calendar for scheduling...",
    });
    
    // Open Google Calendar scheduling link in new tab
    window.open("https://calendar.google.com/calendar/appointments/schedules/AcZssZ1ZOL_n8xU8shr0821mW7RMBDQwFKaT0-rLZwwol24qrw_rwS5wlUAKJGkT4Y8j9_wiTZn-WU3n", "_blank");
  };
  
  return (
    <div className="space-y-6">
      <p className="text-gray-600 mb-6">
        I'm excited about opportunities where I can combine my psychology background 
        with my passion for improving systems and supporting people.
      </p>
      
      <div className="flex flex-col gap-4">
        <Button variant="outline" className="w-full border-sage-600 text-sage-700 hover:bg-sage-50 flex items-center justify-center gap-2">
          <Mail className="h-4 w-4" />
          <a href="mailto:PaytonMHunter7@gmail.com" className="hover:underline">PaytonMHunter7@gmail.com</a>
        </Button>
        
        <Button variant="outline" className="w-full border-sage-600 text-sage-700 hover:bg-sage-50 flex items-center justify-center gap-2">
          <Linkedin className="h-4 w-4" />
          <a href="https://www.linkedin.com/in/paytonmhunter" target="_blank" rel="noopener noreferrer" className="hover:underline">Connect on LinkedIn</a>
        </Button>
        
        <Button 
          variant="outline" 
          className="w-full border-sage-600 text-sage-700 hover:bg-sage-50 flex items-center justify-center gap-2"
          onClick={handleScheduleCall}
        >
          <Calendar className="h-4 w-4" />
          <span>Schedule a 15-minute intro call</span>
        </Button>
      </div>
    </div>
  );
};
